import { render, staticRenderFns } from "./helpActivityDetails.vue?vue&type=template&id=27a2dfa6&scoped=true&"
import script from "./helpActivityDetails.vue?vue&type=script&lang=js&"
export * from "./helpActivityDetails.vue?vue&type=script&lang=js&"
import style0 from "./helpActivityDetails.vue?vue&type=style&index=0&id=27a2dfa6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a2dfa6",
  null
  
)

export default component.exports